import { ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { put, takeEvery } from 'redux-saga/effects';

import { toDto } from '../../../models/adapters/PlaceAdapter';
import { placeUpdated, placeUpdateFailed, updatePlace, UpdatePlaceActionType } from '../../actions/place/updatePlace';
import getAuthenticationToken from '../getAuthenticationToken';
import getProtectedResponse from '../getProtectedResponse';

function* updatePlaceSaga({ payload }: UpdatePlaceActionType) {
  const { place } = payload;
  const token = yield getAuthenticationToken();
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.updatePlace, token, {
    placeDto: toDto(payload.place),
  });
  const timestamp = moment();
  const responsePayload = { timestamp, place };
  if (!response.error) {
    const responseAction = placeUpdated(responsePayload);
    yield put(responseAction);
  } else {
    const responseAction = placeUpdateFailed({ timestamp, placeUuid: place.uuid });
    yield put(responseAction);
  }
}

export default function* watchUpdatePlaceSaga() {
  yield takeEvery(updatePlace, updatePlaceSaga);
}
